import React from "react";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";

interface SignInLayoutProps {
  children: React.ReactNode;
}

const SignInLayout: React.FC<SignInLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  return (
    // ✅ Outer Box: Full viewport coverage with dark background
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#00304f",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        // Ensure no white gaps
        margin: 0,
        padding: 0,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "auto",
      }}
    >
      {/* ✅ Inner Container: Responsive content width */}
      <Container
        component="main"
        maxWidth="sm" // Limits form width on large screens
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          py: { xs: 3, sm: 4, md: 6 }, // Responsive padding
          px: { xs: 2, sm: 3 },
        }}
      >
        {/* Logo Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            mb: { xs: 3, sm: 4 },
            width: "100%",
          }}
        >
          <img
            src="/eap-space-logo.png"
            alt="EAP Space Logo"
            style={{
              width: isMobile ? 200 : isTablet ? 250 : 300,
              maxWidth: "80%",
              height: "auto",
            }}
          />
        </Box>

        {/* Form Content */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            maxWidth: { xs: "100%", sm: 400, md: 450 },
            // Optional: Add a subtle card effect on larger screens
            // backgroundColor: { xs: "transparent", sm: "rgba(255,255,255,0.03)" },
            // borderRadius: { xs: 0, sm: 2 },
            // p: { xs: 0, sm: 3 },
          }}
        >
          {children}
        </Box>
      </Container>
    </Box>
  );
};

export default SignInLayout;
